define(function(require, exports, module) {
    'use strict';

    const _ = require('underscore');
    const $ = require('j');
    const user = require('user');
    const AuthManager = require('managers/auth.manager');
    const server = require('server');
    const languageUtil = require('util/language.util');
    const deviceUtil = require('util/device.util');
    const config = require('config');
    const urlUtil = require('util/url.util');
    var { dispatcher, getDeviceId } = require('bundle');

    module.exports = AuthManager.extend({
        register: function(options) {
            let def = $.Deferred();
            let lang = languageUtil.convertToIMS(user.get('lang'));
            let formData = user.get('formData');
            let registrationInfo = user.get('registrationInfo');
            let deviceType = urlUtil.getLocationParameterByName('deviceType');
            let signUpInfo = {
                signupDeviceType: deviceType ?? deviceUtil.alias,
                signupOsName: deviceUtil.os,
                signupOsVersion: deviceUtil.osVersion,
                signupDeliveryPlatform: deviceUtil.deliveryPlatform.slice(0, 50),
                signupDeviceBrowser: deviceUtil.browserName
            };
            let data = _.extend({}, formData, signUpInfo);

            if (registrationInfo?.playerHash) {
                data = _.extend({}, data, {
                    playerHash: registrationInfo?.playerHash
                });
            }

            if (!lang) {
                return $.Deferred().reject({
                    ID: -1,
                    data: {
                        errorCode: -1,
                        errorMessage: 'User can\'t be logged in',
                        message: 'Failed to get two letter language'
                    }
                });
            }

            data.phone = Playtech.Variables.isSecondPhoneFieldEnabled
                ? data.phone || data.second_phone || data.cellphone
                : data.cellphone || '';

            data.language = lang.toUpperCase();

            if (data.userName && config.get('isUsernameInUppercase')) {
                data.userName = data.userName.toUpperCase();
            }

            if (!data.userName && !data.loginName) {
                user.set('loginMode', 'email');
            }

            data.serial = getDeviceId();
            data.signupDeviceId = data.serial;

            let requests = [
                this._generateSubscriptionRequest(data),
                this._getDepositLimitRequest(data),
                this._getBetLimitRequest(data),
                this._getLossLimitRequest(data)
            ].filter(Boolean);

            let omittedData = _.omit(data, 'daylosslimit', 'weeklosslimit', 'monthlosslimit');

            var extendedOptions = _.extend({}, options, {
                externalToken: registrationInfo?.externalToken,
                personalId: data.personalId
            });

            this._registrationRequest(omittedData, requests, extendedOptions)
                .done(def.resolve)
                .fail(function(error) {
                    if (error.ID === 33006 && error.data.errorCode === 105) {
                        var dataWithoutTC = _.omit(omittedData, 'tcVersion');

                        this._registrationRequest(dataWithoutTC, requests, extendedOptions)
                            .done(def.resolve)
                            .fail(function(e) {
                                options.error();
                                def.reject(e);
                            });
                    } else {
                        options.error();
                        def.reject(error);
                    }
                }.bind(this))
                .then(function() {
                    if (urlUtil.getURLParams()?.at_gd && urlUtil.getURLParams()?.at_gd !== '') {
                        // Cookie name - at_gd_cookie
                        window.document.cookie = `at_gd_cookie=${urlUtil.getURLParams()?.at_gd}; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/`;
                    }
                });

            dispatcher.dispatch('registration:submitted');

            return def.promise();
        },

        _registrationRequest: function(data, requests, options) {
            const def = $.Deferred();
            const token = user.get('signUpVerificationToken');
            const blackbox = this._getIovationBlackbox();
            const request = {
                ID: 31007,
                responses: [31008, 33006],
                description: 'Create Player Info (Register)',
                changeTimestamp: window.Playtech.API.formatter.getDateForIms(new Date()),
                errorLevel: 1,
                ...this._refineRegistrationData(data),
                ...token && { token },
                ...blackbox && {
                    customData: [
                        {
                            'key': 'iovationBlackbox',
                            'value': blackbox
                        }
                    ]
                }
            };

            server.send(this.registrationRequestFilter(request))
                .done(function(response) {
                    const { playerCode, userId } = response.data;

                    this._afterRegistrationBatchRequest({ ...data, playerCode, userId }, requests)
                        .always(function(msg) {
                            window.sessionStorage.setItem('playerCode', playerCode);
                            this._successRegistration({ ...data, playerCode, userId }, options);
                            def.resolve(msg);
                        }.bind(this));
                }.bind(this))
                .fail(function(error) {
                    def.reject(error);
                });

            return def.promise();
        }
    });
});
